// Contexto da loja: qual empresa, qual estabelecimento e, no modo mesa, qual localizador.
export type Contexto = {
  empresaId?: string;
  estabelecimentoId?: string;
  localizadorId?: string;
};

function valor(id?: string): string {
  return id || '';
}

// A sacola so pode ser zerada quando o cliente entra em OUTRO contexto - ler o QR de
// outra mesa, por exemplo. Ir do cardapio para o checkout carrega os mesmos parametros
// na rota; zerar ali esvaziava a sacola no meio do caminho.
export function contextoMudou(atual: Contexto, novo: Contexto): boolean {
  return (
    valor(atual?.empresaId) !== valor(novo?.empresaId) ||
    valor(atual?.estabelecimentoId) !== valor(novo?.estabelecimentoId) ||
    valor(atual?.localizadorId) !== valor(novo?.localizadorId)
  );
}
